export const label = 'Номер пакування (не обов’язково)';
export const maxLength = 20;
export const errors = {
  maxlength: `Максимальна довжина ${maxLength} символів`,
};
